import { useContext } from 'preact/hooks';

import KeepExploring        from '../components/KeepExploring.jsx';
import useKeepExploringData from '../hooks/useKeepExploringData.js';
import { routes }           from '../data/routes.js';
import GlobalContext        from '../context/GlobalContext.js';

const KeepExploringDefault = () => {
  const { pathroot } = useContext(GlobalContext);
  const { data, isLoading, error } = useKeepExploringData();

  const keepExploringElements = [
    {
      heading: 'Erfahren Sie mehr über Rolex',
      image: 'discover-rolex',
      link_to: pathroot + routes['discover-rolex'].de
    },
    {
      heading: 'Rolex Armbanduhren',
      image: 'rolex-watches',
      link_to: pathroot + routes['watches'].de
    },
    {
      heading: 'Neue Modelle 2025',
      image: 'new-watches-2025',
      link_to: pathroot + routes['new-watches-2025'].de
    },
    {
      heading: 'Uhrmacherkunst',
      image: 'watchmaking',
      link_to: pathroot + routes['watchmaking'].de
    },
    {
      heading: 'Wartung',
      image: 'servicing',
      link_to: pathroot + routes['servicing'].de
    },
    {
      heading: 'Welt von Rolex',
      image: 'world-of-rolex',
      link_to: pathroot + routes['world-of-rolex'].de
    },
    {
      heading: 'Kontaktieren Sie uns',
      image: 'contact-us',
      link_to: pathroot + routes['contact-us'].de
    },
  ]

  // Todo loading state and error state
  if (!isLoading && !error) {
    return (
      <KeepExploring fullLengthsSlide elements={keepExploringElements} assets={data.global_asset[0].asset}/>
    )
  } else {
    return null;
  }
};

export default KeepExploringDefault;
